/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

const script = document.createElement('script');
script.src = `https://www.google.com/recaptcha/api.js?render=${environment.reCaptchaSiteKey}`;
script.async = true;
script.defer = true;
document.head.appendChild(script);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
